export default "__VITE_ASSET__B8OA_MfK__"